export const ADD_EMPLOYEE = "ADD_EMPLOYEE";
export const ADD_EMPLOYEE_SUCCESS = "ADD_EMPLOYEE_SUCCESS";
export const ADD_EMPLOYEE_FAIL = "ADD_EMPLOYEE_FAIL";

export const GET_STAFF = "GET_STAFF";
export const GET_STAFF_SUCCESS = "GET_STAFF_SUCCESS";
export const GET_STAFF_FAIL = "GET_STAFF_FAIL";

export const GET_STAFF_BY_EMAIL = "GET_STAFF_EMAIL";
export const GET_STAFF_BY_EMAIL_SUCCESS = "GET_STAFF_EMAIL_SUCCESS";
export const GET_STAFF_BY_EMAIL_FAIL = "GET_STAFF_EMAIL_FAIL";

export const GET_STAFF_BY_ID = "GET_STAFF_BY_ID";
export const GET_STAFF_BY_ID_SUCCESS = "GET_STAFF_BY_ID_SUCCESS";
export const GET_STAFF_BY_ID_FAIL = "GET_STAFF_BY_ID_FAIL";

export const DELETE_STAFF = "DELETE_STAFF";
export const DELETE_STAFF_SUCCESS = "DELETE_STAFF_SUCCESS";
export const DELETE_STAFF_FAIL = "DELETE_STAFF_FAIL";

export const UPDATE_EMPLOYEE = "UPDATE_EMPLOYEE";
export const UPDATE_EMPLOYEE_SUCCESS = "UPDATE_EMPLOYEE_SUCCESS";
export const UPDATE_EMPLOYEE_FAIL = "UPDATE_EMPLOYEE_FAIL";

export const GET_LANG_TIME_ZONE = "GET_LANG_TIME_ZONE";
export const GET_LANG_TIME_ZONE_SUCCESS = "GET_LANG_TIME_ZONE_SUCCESS";
export const GET_LANG_TIME_ZONE_FAIL = "GET_LANG_TIME_ZONE_FAIL";

export const GET_STAFF_CALENDER = "GET_STAFF_CALENDER";
export const GET_STAFF_CALENDER_SUCCESS = "GET_STAFF_CALENDER_SUCCESS";
export const GET_STAFF_CALENDER_FAIL = "GET_STAFF_CALENDER_FAIL";

export const POST_STAFF_DOC = "POST_STAFF_DOC";
export const POST_STAFF_DOC_SUCCESS = "POST_STAFF_DOC_SUCCESS";
export const POST_STAFF_DOC_FAIL = "POST_STAFF_DOC_FAIL";

export const STAFF_STATE = "STAFF_STATE";
export const STAFF_STATE_SUCCESS = "STAFF_STATE_SUCCESS";
export const STAFF_STATE_FAIL = "STAFF_STATE_FAIL";

export const GET_EMPLOYEE_PROFILE_DOCS = "GET_EMPLOYEE_PROFILE_DOCS";
export const GET_EMPLOYEE_PROFILE_DOCS_SUCCESS = "GET_EMPLOYEE_PROFILE_DOCS_SUCCESS";
export const GET_EMPLOYEE_PROFILE_DOCS_FAIL = "GET_EMPLOYEE_PROFILE_DOCS_FAIL";

export const APPROVE_EMP_DOCS = "APPROVE_EMP_DOCS";
export const APPROVE_EMP_DOCS_SUCCESS = "APPROVE_EMP_DOCS_SUCCESS";
export const APPROVE_EMP_DOCS_FAIL = "APPROVE_EMP_DOCS_FAIL";

export const APPROVE_EMP_VEHICLE_DOCS = "APPROVE_EMP_VEHICLE_DOCS";
export const APPROVE_EMP_VEHICLE_DOCS_SUCCESS = "APPROVE_EMP_VEHICLE_DOCS_SUCCESS";
export const APPROVE_EMP_VEHICLE_DOCS_FAIL = "APPROVE_EMP_VEHICLE_DOCS_FAIL";

export const NOTIFY_EMPLOYEE = "NOTIFY_EMPLOYEE";
export const NOTIFY_EMPLOYEE_SUCCESS = "NOTIFY_EMPLOYEE_SUCCESS";
export const NOTIFY_EMPLOYEE_FAIL = "NOTIFY_EMPLOYEE_FAIL";

export const EMPLOYEES_EXPIRE_DOCS_LIST = "EMPLOYEES_EXPIRE_DOCS_LIST";
export const EMPLOYEES_EXPIRE_DOCS_LIST_SUCCESS = "EMPLOYEES_EXPIRE_DOCS_LIST_SUCCESS";
export const EMPLOYEES_EXPIRE_DOCS_LIST_FAIL = "EMPLOYEES_EXPIRE_DOCS_LIST_FAIL";

export const AVAILABILITY = "AVAILABILITY";
export const AVAILABILITY_SUCCESS = "AVAILABILITY_SUCCESS";
export const AVAILABILITY_FAIL = "AVAILABILITY_FAIL";

export const DELETE_STAFF_DOC = "DELETE_STAFF_DOC";
export const DELETE_STAFF_DOC_SUCCESS = "DELETE_STAFF_DOC_SUCCESS";
export const DELETE_STAFF_DOC_FAIL = "DELETE_STAFF_DOC_FAIL";

export const COPY_EMPLOYEE_PROFILE = "COPY_EMPLOYEE_PROFILE";
export const COPY_EMPLOYEE_PROFILE_SUCCESS = "COPY_EMPLOYEE_PROFILE_SUCCESS";
export const COPY_EMPLOYEE_PROFILE_FAIL = "COPY_EMPLOYEE_PROFILE_FAIL";

export const GENERATE_TIME_SHEET = "GENERATE_TIME_SHEET";
export const GENERATE_TIME_SHEET_SUCCESS = "GENERATE_TIME_SHEET_SUCCESS";
export const GENERATE_TIME_SHEET_FAIL = "GENERATE_TIME_SHEET_FAIL";

export const GET_ADMIN_TIMESHEET_LIST = "GET_ADMIN_TIMESHEET_LIST";
export const GET_ADMIN_TIMESHEET_LIST_SUCCESS = "GET_ADMIN_TIMESHEET_LIST_SUCCESS";
export const GET_ADMIN_TIMESHEET_LIST_FAIL = "GET_ADMIN_TIMESHEET_LIST_FAIL";

export const SEND_TIME_SHEET_TO_SUPPORT_WORKER = "SEND_TIME_SHEET_TO_SUPPORT_WORKER";
export const SEND_TIME_SHEET_TO_SUPPORT_WORKER_SUCCESS = "SEND_TIME_SHEET_TO_SUPPORT_WORKER_SUCCESS";
export const SEND_TIME_SHEET_TO_SUPPORT_WORKER_FAIL = "SEND_TIME_SHEET_TO_SUPPORT_WORKER_FAIL";

export const RE_SUBMIT_TIME_SHEET = "RE_SUBMIT_TIME_SHEET";
export const RE_SUBMIT_TIME_SHEET_SUCCESS = "RE_SUBMIT_TIME_SHEET_SUCCESS";
export const RE_SUBMIT_TIME_SHEET_FAIL = "RE_SUBMIT_TIME_SHEET_FAIL";

export const REMOVE_TIME_SHEET = "REMOVE_TIME_SHEET";
export const REMOVE_TIME_SHEET_SUCCESS = "REMOVE_TIME_SHEET_SUCCESS";
export const REMOVE_TIME_SHEET_FAIL = "REMOVE_TIME_SHEET_FAIL";

export const GET_EMPLOYEE_RATING_REPORT = "GET_EMPLOYEE_RATING_REPORT";
export const GET_EMPLOYEE_RATING_REPORT_SUCCESS = "GET_EMPLOYEE_RATING_REPORT_SUCCESS";
export const GET_EMPLOYEE_RATING_REPORT_FAIL = "GET_EMPLOYEE_RATING_REPORT_FAIL";

export const DELETE_TRAINING_DOC = "DELETE_TRAINING_DOC";
export const DELETE_TRAINING_DOC_SUCCESS = "DELETE_TRAINING_DOC_SUCCESS";
export const DELETE_TRAINING_DOC_FAIL = "DELETE_TRAINING_DOC_FAIL";
